import { Component, OnInit } from '@angular/core';
import {NgForm} from '@angular/forms';
import {Router, ActivatedRoute, Params} from '@angular/router';
import {SiteuserService} from '../../services/siteuser.service';
import {LanguageService} from '../../services/language.service'; 

@Component({
  selector: 'app-verifyregister',
  templateUrl: './verifyregister.component.html',
  styleUrls: ['./verifyregister.component.css']
})
export class VerifyregisterComponent implements OnInit {
  rqsFailSts :boolean;
  errmsg:string = '';
  errmsg_ar:string = '';
  sucsmsg:string = '';
  sucsmsg_ar:string = '';
  isLoading:boolean = false;
  forgetpass:number;
  isForgot:boolean;
  showLang:string;
  
  constructor(private siteObj:SiteuserService, 
    private router:Router,private route:ActivatedRoute,private langObj:LanguageService) {
      this.langObj.langStr.subscribe((data)=>{ 
        this.showLang = data;
      });
     }

  ngOnInit(): void {

    this.route.params.subscribe((params:Params)=>{
      if(params['isForgotpas']){
        this.isForgot = true;
        this.forgetpass = params['isForgotpas'];
      }
    })

    this.showLang = localStorage.getItem("showLang");
     if(this.showLang == null && this.showLang == undefined){
      this.showLang = 'en';
     }

  } 

  otpFormSubmit(frm:NgForm){
    this.isLoading = true;    
    var userid = localStorage.getItem('p_uid');
    this.siteObj.verifyRegisterOtp(frm.value.otp,this.isForgot,userid).subscribe(sbsData=>{
      this.isLoading = false;
      if(sbsData['success'] == true){
        if(this.forgetpass == 1){
          this.router.navigate(['reset-password']);
        }else{
          this.router.navigate(['login']);
        }
        
      }else{
        this.rqsFailSts = true;
        this.sucsmsg='';
        this.sucsmsg_ar='';
        this.errmsg = sbsData['message'];
        this.errmsg_ar = sbsData['message_ar'];
      }
    })
  }

  resendOTP(){ 
    if(this.isForgot){
      var email = localStorage.getItem('p_email');
    }else{
      var email = localStorage.getItem('r_email');
    }
    
    this.siteObj.resendOtp(email,this.isForgot).subscribe(sbsData=>{
      if(sbsData['otp']){
        this.errmsg="";
        this.errmsg_ar="";
        this.sucsmsg = "OTP sent successfully";
        this.sucsmsg_ar = "تم إرسال OTP بنجاح";
      }else{
        this.sucsmsg='';
        this.sucsmsg_ar='';
        this.errmsg = "Something went wrong";
        this.errmsg_ar = "هناك خطأ ما";
      }
    });
  }

}
